import { render } from "./SupervisedEntitiesGroupTree.vue?vue&type=template&id=4d4452b0"
import script from "./SupervisedEntitiesGroupTree.vue?vue&type=script&lang=js"
export * from "./SupervisedEntitiesGroupTree.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\FinanssivalvontaCMS\\Finanssivalvonta.web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__